import {Base64Tools} from '../sdk/utils/base64Tools'
import {isValidConfId} from './validation'
import {resolveBackendUrls} from './backends'

function getUrlParams(): URLSearchParams {
    return new URLSearchParams(window.location.search)
}

export function getSandboxId(): string {
    return getUrlParams().get('sandbox') ?? ''
}

export function isDebug(): boolean {
    return getUrlParams().get('debug') === 'true'
}

export function isRelayOnly(): boolean {
    return getUrlParams().get('relay_only') === 'true'
}

export function isTcpOnly(): boolean {
    return getUrlParams().get('tcp_only') === 'true'
}

export function isTlsOnly(): boolean {
    return getUrlParams().get('tls_only') === 'true'
}

// ВНИМАНИЕ: на мейнстрим-браузерах и libwebrtc (в т.ч. нативные клиенты) медиа-relay
// НЕ ходит через TURN-over-DTLS — turns:…?transport=udp поднимается как TURNS-over-TLS/TCP.
// То есть на практике этот флаг эквивалентен tls_only; отдельный DTLS-медиарелей появится
// только со стеком, реализующим RFC 7350. coturn при этом для DTLS сконфигурен корректно.
export function isDtlsOnly(): boolean {
    return getUrlParams().get('dtls_only') === 'true'
}

export function isShowPlaybackButton(): boolean {
    return getUrlParams().get('show_playback_button') === 'true'
}

export function getConfId(): string {
    const match = window.location.pathname.match(/^\/r\/([^/]+)/)
    const confId = match?.[1]
    if (!isValidConfId(confId)) {
        throw "incorrect confId"
    }
    return confId
}

export function getServerUrls(): string[] {
    return resolveBackendUrls()
}

export function participantId(): string {
    const cKey = "cParticipantId"
    let participantId = sessionStorage.getItem(cKey)
    if (!participantId) {
        participantId = Base64Tools.Base64FromRandomUint64()
        sessionStorage.setItem(cKey, participantId)
    }
    return participantId
}
